import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.items.length
    ? _c(
        "div",
        {
          staticClass: "price-equipment d-flex ga-4 overflow-x-auto pb-1",
          attrs: { "data-qa": "lpu_page_price_equipment_list" },
        },
        _vm._l(_vm.items, function (item) {
          return _c(
            "div",
            {
              key: item.name,
              staticClass: "price-equipment__card flex-shrink-0",
              attrs: { "data-qa": "lpu_page_price_equipment_item" },
            },
            [
              item.img?.thumb
                ? _c(VImg, {
                    staticClass: "rounded-20 mb-2",
                    attrs: {
                      src: item.img.thumb,
                      width: "160",
                      height: "120",
                      cover: "",
                      alt: item.name,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "text-subtitle-2 text--text" }, [
                _vm._v("\n      " + _vm._s(item.name) + "\n    "),
              ]),
              _vm._v(" "),
              _setup.attributeLabel(item)
                ? _c(
                    "div",
                    { staticClass: "text-body-2 text-secondary--text" },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(_setup.attributeLabel(item)) +
                          "\n    "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }